import { Service } from "./index";
// 总后台 - [服务商管理] 条件查询服务商列表
export function findServiceListByTerm(data) {
  return Service({
    url: "amall_user/service/findServiceListByTerm",
    method: "post",
    data: data
  });
}
// 商户后台 根据商户ID查询详情信息
export function findShopByShopId(data) {
  return Service({
    url: "amall_user/shop/findShopByShopId",
    method: "post",
    params: data
  });
}
//SERVICE - [通用API] 获取全国省市信息
export function getPcdAll(data) {
  return Service({
    url: "/amall_user/user/getPcdAll",
    method: "post",
    params: data
  });
}
//总后台 - [商户管理] 编辑商户客服信息
export function updateShopCustomerService(data) {
  return Service({
    url: "/amall_user/shop/updateShopCustomerService",
    method: "post",
    params: data
  });
}
//WEB - [通用API] 查询当前商户信息
export function findShopItem(data) {
  return Service({
    url: "/amall_user/shop/findShopItem",
    method: "post",
    params: data
  });
}
//WEB - [通用API] 查询当前商户信息
export function findBank(data) {
  return Service({
    url: "/amall_user/user/findBank",
    method: "post",
    params: data
  });
}
//通用API - [提现管理] 条件查询提现列表  提现记录页面
export function findWithdrawalList(data) {
  return Service({
    url: "/amall_user/user/findWithdrawalList",
    method: "post",
    data: data
  });
}

//总后台 - [通用API] 条件查询钱包收支明细   钱包下面列表
export function findBillByItem(data) {
  return Service({
    url: "/amall_user/admin/findBillByItem",
    method: "post",
    data: data
  });
}
//APPLET - [银行卡管理] 绑定银行卡
export function serviceLinkBank(data) {
  return Service({
    url: "/amall_user/user/serviceLinkBank",
    method: "post",
    data: data
  });
}
//APPLET - [银行卡管理] 解绑银行卡
export function serviceUnboundBank(data) {
  return Service({
    url: "/amall_user/user/serviceUnboundBank",
    method: "post",
    params: data
  });
}
//APPLET - [提现管理] 提现申请
export function withdrawalAppley(data) {
  return Service({
    url: "/amall_user/user/withdrawalAppley",
    method: "post",
    params: data
  });
}

//APPLET - [添加成员] 商户添加成员
export function addShopMember(data) {
  return Service({
    url: "/amall_user/shop/addShopMember",
    method: "post",
    params: data
  });
}
//APPLET - [添加成员] 查询当前商户所有成员
export function findShopMamberAll(data) {
  return Service({
    url: "/amall_user/shop/findShopMamberAll",
    method: "post",
    params: data
  });
}
//APPLET - [添加成员] 编辑商户成员
export function updateShopMember(data) {
  return Service({
    url: "/amall_user/shop/updateShopMember",
    method: "post",
    params: data
  });
}
//APPLET - [添加成员] 商户删除成员
export function deleteShopMember(data) {
  return Service({
    url: "/amall_user/shop/deleteShopMember",
    method: "post",
    params: data
  });
}

//通用API - [通用API] 查询当前登录用户信息,根据当前登录的角色
export function findLogin(data) {
  return Service({
    url: "/amall_user/user/findLogin",
    method: "post",
    params: data
  });
}
//通用API - [通用API] 根据手机号查询业主
export function findUserListByMobile(data) {
  return Service({
    url: "amall_user/user/findUserListByMobile",
    method: "post",
    params: data
  });
}

/**
 * 通用API - [通用API] 通过商户成员ID(如果传空,则查询当前登录成员ID)获取成员信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function findShopMemberById(data) {
  return Service({
    url: "amall_user/shop/findShopMemberById",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}

/**
 * 总后台_PC - [通用API] 根据ID查询服务商,传空则查询当前登录服务商
 * @export
 * @param {*} data
 * @return {*}
 */
export function findServiceByserviceId(data) {
  return Service({
    url: "amall_user/service/findServiceByserviceId",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
//通用API - [通用API] 根据工程订单id查询可指派的服务商
export function findServiceByTag(data) {
  return Service({
    url: "amall_user/service/findServiceByTag",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/service/user.js